module.exports = __webpack_public_path__ + "img/SalamBrand.5d2f11b5.svg";